<template>
  <div class="swiper-box" :class="full==1?'curr':''">
    <template v-if="banners.length == 1">
      <div class="swiper-slide" v-for="(item,index) in banners" :key="index">
        <template v-if="type == 'home'">
          <img :src="item.imgurl" width="100%" height="100%" data-type="1" @click="gotoLink(item.richid)" v-if="item.isrich==1">
          <img :src="item.imgurl" width="100%" height="100%" data-type="1" @click="gotoWeb(item.url)" v-else-if="item.url">
          <img :src="item.imgurl" width="100%" height="100%" data-type="1" @click="seeImg(index)" v-else>
        </template>
        <template v-if="type == 'view'">
          <img :src="item.img" width="100%" height="100%" data-type="2"  @click="gotoVideo(item)" v-if="item.link">

          <div class="full-box" v-else-if="item.video&&item.isvideo==1">
            <video :id="'myVideo'+index" width="100%" loop="loop" webkit-playsinline="true" x5-video-player-type="h5-page" x5-video-player-fullscreen="true"
                   playsinline="" preload="auto" :src="item.video" :poster="item.img" class="video_box" @click="playVideo(index)"></video>
            <img class="icon-video" src="../assets/icon_play_btn03.png" alt="">
            <img class="icon-fulls" src="../assets/fulls.png" alt="" @click="fullClick(index)">
          </div>

          <img :src="item.img" width="100%" height="100%" data-type="3" @click="seeImg(index)" v-else>
        </template>
        <template v-if="type == 'videoc'">
          <img :src="item.img" width="100%" height="100%" data-type="1" @click="gotoVideoc(item)">
        </template>
        <template v-if="type != 'home' && type != 'view' && type != 'videoc'">
          <img :src="item" width="100%" height="100%" data-type="4" @click="seeImg(index)">
        </template>
      </div>
    </template>

    <template v-if="banners.length > 1">
      <swiper :options="swiperOption" id="mySwiper" ref="mySwiper" @someSwiperEvent="callback" v-if="banners.length > 1">
      <!--<div class="swiper-container" id="mySwiper" v-if="banners.length >= 1">-->
        <!--<div class="swiper-wrapper">-->
          <div class="swiper-slide" :class="(item.video&&item.isvideo==1&&playing==1&&full==1)?'swiper-no-swiping':''" v-for="(item,index) in banners" :key="index">
            <template v-if="type == 'home'">
              <img :src="item.imgurl" width="100%" height="100%" data-type="1" @click="gotoLink(item.richid)" v-if="item.isrich==1">
              <img :src="item.imgurl" width="100%" height="100%" data-type="1" @click="gotoWeb(item.url)" v-else-if="item.url">
              <img :src="item.imgurl" width="100%" height="100%" data-type="1" @click="seeImg(index)" v-else>
            </template>
            <template v-if="type == 'view'">
              <img :src="item.img" width="100%" height="100%" data-type="2"  @click="gotoVideo(item)" v-if="item.link">

              <div class="full-box" v-else-if="item.video&&item.isvideo==1">
                <video :id="'myVideo'+index" width="100%" loop="loop" webkit-playsinline="true" x5-video-player-type="h5-page" x5-video-player-fullscreen="true"
                       playsinline="" preload="auto" :src="item.video" :poster="item.img"  class="video_box" @click="playVideo(index)"></video>
                <img class="icon-video" src="../assets/icon_play_btn03.png" alt="" v-if="playing!=1">
                <img class="icon-fulls" src="../assets/fulls.png" alt="" @click="fullClick(index)">
              </div>

              <img :src="item.img" width="100%" height="100%" data-type="3" @click="seeImg(index)" v-else>

            </template>
            <template v-if="type == 'videoc'">
              <img :src="item.img" width="100%" height="100%" data-type="1" @click="gotoVideoc(item)">
            </template>
            <template v-if="type != 'home' && type != 'view' && type != 'videoc'">
              <img :src="item" width="100%" height="100%" data-type="4" @click="seeImg(index)">
            </template>
          </div>
        <!--</div>-->

        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-scrollbar" slot="scrollbar"></div>
      </swiper>
    </template>
  </div>
</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import { swiper, swiperSlide,Swiper } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import {wxImgPreview} from '@/utils/wechat'
  var self
  export default {
    data(){
      return {
        a: 1,
        mySwiper: null,
        playing: 0,//1：播放
        full:0, //1全屏
        swiperOption: {
          initialSlide: 0,
          height: 380,
          speed: 500,//切换速度
          watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
//          loop: true,//开启循环模式
//          autoplay: {
//            delay: 3000,
//            disableOnInteraction: false
//          },
          noSwiping: true,
          loop: false,//开启循环模式
          autoplay: this.type == 'view' ? false : true,
          slidesPerView: 1,
          spaceBetween: 10,
          observeParents:true,
          observer: true,
          preventClicksPropagation: true,//阻止click冒泡。拖动Swiper时阻止click事件。
          simulateTouch: false,//鼠标模拟手机触摸。默认为true，Swiper接受鼠标点击、拖动。
          pagination: {
            el: ".swiper-pagination",
            clickable: true //允许点击小圆点跳转
          },
          on: {
//            touchEnd: function (event) {
//              //你的事件
//            },
            slideChangeTransitionEnd: function(){
              var allVideo = document.getElementById('mySwiper').getElementsByTagName("video");
              for(var i=0; i<allVideo.length; i++){
                allVideo[i].pause();
                self.playing = 0;
              }
            },
          }
        },

      }
    },
    props: ['banners','type'],
    mounted() {

      self = this;
console.log(this.banners)
    },
    components: {
      swiper,
      swiperSlide
    },
    methods: {
      callback(a){
        console.log(a)
      },

      //图片预览
      seeImg(ind){
        let curSrc = '';
        let srcList = [];

        if(this.type == "home"){
          curSrc = this.banners[ind].imgurl;
          for(var i=0; i<this.banners.length; i++){
            srcList.push(this.banners[i].imgurl)
          }
        }else if(this.type == "view"){
          curSrc = this.banners[ind].img;
          for(var i=0; i<this.banners.length; i++){
            srcList.push(this.banners[i].img)
          }
        }else {
          curSrc = this.banners[ind];
          srcList = this.banners;
        }
        wxImgPreview(curSrc,srcList);
      },

      //跳转到使用手册
      gotoLink(id){
        this.$router.push({
          path: `/agreement?${'id='+id}`
        });
      },

      gotoVideoc(item){
        this.$router.push({
          path: `/video-list-cd-detail?${'id='+ item.id }`
        });
      },

      //跳转到外部链接
      gotoWeb(url){
        if(url.indexOf("http") > -1){
          window.location = url
        }else{
          this.$router.push({
            path: url
          });
        }

      },

      //跳转到专辑详情
      gotoVideo(item){

        let appKey =  getStore("appKey") || "";
        if(appKey){
          appKey = appKey.appKey
        }

        var link = item.link;
        if(item.isvideo==2){
          window.location = link;
        }else {
          let id = link.split("?")[1].split("&")[0].split("=")[1];
          let shopid = link.split("?")[1].split("&")[1].split("=")[1];
          if(link.indexOf("bagtype=1") == -1){
            this.$router.push({
              path: `/video-play?${'id='+id+'&spotid=&shopid='+shopid+'&appKey='+appKey}`
            });
          }else {
            this.$router.push({
              path: `/video-play1?${'bagtype=1&id='+id+'&spotid=&shopid='+shopid+'&appKey='+appKey}`
            });
          }
        }

      },

      platSystem(){
        let ua = navigator.userAgent.toLowerCase();
        let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
        let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          this.platIOS = 1
        } else if (/(Android)/i.test(navigator.userAgent)) {
          this.platIOS = 0
        }
      },


      //全屏
      fullClick: function(ind){
        var Video = document.getElementById("myVideo"+ind);
        if(Video.paused){
          Video.play();
          this.playing = 1;
        }
        if(this.full==1){
          this.full = 0;
        }else {
          this.full = 1;
        }
      },
      //播放或暂停
      playVideo(ind){
        var Video = document.getElementById("myVideo"+ind);
        if(this.playing != 1){
          Video.play();
          this.playing = 1;
        }else {
          Video.pause();
          this.playing = 0;
        }

      },

    },
  }
</script>

<style>
  .swiper-box {width: 100%;height: 100%;border-radius: .07rem;overflow: hidden;}
  .swiper-box .swiper-container {width: 100%;height: 100%;}
  .swiper-box .swiper-slide img {width: 100%;height: 100%;object-fit: cover;background:url(https://jpjs.geeker.com.cn/frame/images/default_bg.png) no-repeat 50% ;}
  .swiper-scrollbar, .swiper-button-prev, .swiper-button-next {display: none;}
  .swiper-pagination-bullet { opacity: 1; width: .08rem; height: .08rem; margin: 0 .05rem!important;background: #bdbdbd!important;}
  .swiper-pagination-bullet-active { width: .25rem;background: #fff!important; border-radius: .08rem; }
  .swiper-box .swiper-pagination {position: absolute;left: 25%;right: 0;bottom: .16rem;width: 50%;}
  .swiper-con .swiper-box .swiper-pagination{bottom: .4rem;}

  .sm .swiper-con .swiper-box .swiper-pagination{bottom: .12rem!important;}
  .sm .swiper-con .swiper-pagination-bullet{width: .12rem!important;height: .12rem!important;margin:0 0.08rem!important;background: rgba(0,0,0,.4);}
  .sm .swiper-con .swiper-pagination-bullet-active{width: .24rem!important;height: .12rem!important;background: #000;}



  .full-box video{width: 100%;height: 100%;object-fit: cover;vertical-align: baseline;background-color: #000;}
  .swiper-container .full-box{position: relative;width: 100%;height: 100%;display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center}


  .swiper-container .swiper-slide .icon-video{position: absolute;left: 50%;top: 50%;z-index:1;width: .72rem;height: .72rem;transform: translate(-50%,-50%);background: none;pointer-events: none;}
  .swiper-container .swiper-slide .icon-fulls{position: absolute;left: .23rem; top: .23rem; z-index: 1; width: .52rem; height: .52rem;background: none;}

  .swiper-box.curr{position: fixed;left:0;top:0;right:0;bottom:0; width: 100%; height: 100%;z-index: 999;}
  .swiper-box.curr .swiper-container .full-box video{width: 100vh;-webkit-transform: rotate(90deg); transform: rotate(90deg); }
  .swiper-box.curr .swiper-slide .icon-fulls{right:.23rem;left: auto; }
</style>






// WEBPACK FOOTER //
// src/components/Swiper.vue